import type { OverviewResponse } from "contracts/api/dashboard/responses";
import { pageHealthClass } from "./scanModel";
export function Metric(props: { label: string; value: string }) {
  return (
    <div class="scan-metric">
      <span>{props.label}</span>
      <strong>{props.value}</strong>
    </div>
  );
}

export function Score(props: { value: number | null }) {
  return (
    <span class={`scan-score-pill scan-score-${pageHealthClass(props.value)}`}>
      {props.value ?? "--"}
    </span>
  );
}

export function matchLabel(match: string): string {
  switch (match) {
    case "id":
      return "ID match";
    case "path":
      return "Path fallback";
    case "path_without_query":
      return "Path fallback";
    default:
      return "Unresolved";
  }
}

export function requireData(data: OverviewResponse | null): OverviewResponse {
  if (!data) {
    throw new Error("Scan data is unavailable.");
  }
  return data;
}
